import React from "react";
import "./Program.css";
import {programsData} from "../../data/programsData";
import RightArrow from "../../assets/rightArrow.png";
import { Link } from "react-scroll";
const Programs = () => {
  return (
    <div>
      <div className="Programs" id="Programs">
        {/*header*/}
        <div className="programs-header">
        <span className="stroke-text">Explore our</span>
        <span>Programms</span>
          <span className="stroke-text">To Shape You</span>
        </div>
        <div className="program-categories">
        {programsData.map((program) => (
            <div className="category" key={program.id}>
            {program.image}
            <span>{program.heading}</span>
            <span>{program.details}</span>
            <div className="join-now" >
                <span>
                  Join Now
                </span>
                <img src={RightArrow} alt="" /></div>
            </div>
            ))}
        </div>
      </div>
    </div>
  );
};

export default Programs;
